<template>
  <Modal
    v-model="_value"
    width="500"
    title="删除两客一危一重车辆分析报告"
    @on-visible-change="visibleChange"
    ok-text="确认处理"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form  :label-width="80">
      <FormItem prop="selectTime">
        <DatePicker size="small" type="daterange" v-model="selectAnalysisDatetime" placeholder="选择日期"
                    style="margin-right: 3px; width: 200px;"></DatePicker>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'deletegddlysjgvehicleanalyzereportmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      selectAnalysisDatetime: []
    }
  },
  methods: {
    ...mapActions([
      'GdDlysjgVehicleAnalyzeReportServ_DeleteByAnalyzeDatetimeRange',
      'AlarmAnalysisServ_GetDetail'
    ]),
    onOk () {
      console.log('onOk')
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认删除</p>',
        onOk: () => {
          if (!this.selectAnalysisDatetime[0] || !this.selectAnalysisDatetime[1]) {
            this.$Message.error('无效时间')
            return
          }
          let start = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let end = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          store.dispatch('GdDlysjgVehicleAnalyzeReportServ_DeleteByAnalyzeDatetimeRange', {
            params: { start: start, end: end }
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.selectAnalysisDatetime = []
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
